/* eslint-disable react/destructuring-assignment */
import { GetHcsAnnContactByIdResponseIds } from '@toktokdoctech/tokapi-client'
import { uneditableRppsRelatedFieldInfo } from '../../../utils/stringUtils'
import { FormFieldProps } from '../../Common/form/formField/_props'
import FormField from '../../Common/form/formField/FormField'
import { useFormContextContact } from './_utils'

const ContactFormField = <T,>(props: FormFieldProps<GetHcsAnnContactByIdResponseIds, T>) => {
    const { name } = props
    const { resetField } = useFormContextContact()
    const handleClear = () => {
        if (name) {
            resetField(name, {
                defaultValue: '',
                keepDirty: true,
                keepError: false,
                keepTouched: true,
            })
        }
    }

    return <FormField {...props} locked tooltipTitle={uneditableRppsRelatedFieldInfo} onClear={handleClear} />
}

export default ContactFormField
